import L from 'leaflet';

export const normalizeMapPoint = (point) => {
  if (!point) return null;

  if (Array.isArray(point)) {
    const lat = Number(point[0]);
    const lng = Number(point[1]);
    return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
  }

  if (typeof point === 'object') {
    const lat = Number(point.lat ?? point.latitude);
    const lng = Number(point.lng ?? point.longitude);
    return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
  }

  return null;
};

const resolveSinglePointZoom = (
  map,
  { singlePointMinZoom = 15, singlePointMaxZoom = null } = {},
) => {
  const currentZoom = Number(map?.getZoom?.());
  const baselineZoom = Number.isFinite(currentZoom) ? currentZoom : singlePointMinZoom;
  let zoom = Math.max(baselineZoom, singlePointMinZoom);
  if (Number.isFinite(singlePointMaxZoom)) {
    zoom = Math.min(zoom, singlePointMaxZoom);
  }
  return zoom;
};

export const focusMapOnGeometry = (map, points = [], options = {}) => {
  if (!map || !Array.isArray(points)) return false;

  const normalizedPoints = points.map(normalizeMapPoint).filter(Boolean);
  if (!normalizedPoints.length) return false;

  const { padding = [60, 60], maxZoom = 18, animate } = options;

  if (normalizedPoints.length === 1) {
    const target = normalizedPoints[0];
    const zoom = resolveSinglePointZoom(map, options);
    const setViewOptions = typeof animate === 'boolean' ? { animate } : undefined;
    map.setView([target.lat, target.lng], zoom, setViewOptions);
    return true;
  }

  const bounds = L.latLngBounds(normalizedPoints.map((point) => L.latLng(point.lat, point.lng)));
  if (!bounds?.isValid?.()) return false;

  const fitOptions = { padding, maxZoom };
  if (typeof animate === 'boolean') {
    fitOptions.animate = animate;
  }
  map.fitBounds(bounds, fitOptions);
  return true;
};

export default focusMapOnGeometry;
